export const SET_SUPPLIERS = "setSuppliers";
export const SET_SUPPLIER = "setSupplier";
export const SET_PRODUCTS = "setProducts";
export const SET_PRODUCT = "setProduct";



// WEBPACK FOOTER //
// ./src/store/mutations.type.js